import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=76bb3669&"
import script from "./LangSwitch.vue?vue&type=script&lang=ts&"
export * from "./LangSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LangSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports